import * as React from "react";
import { useMemo } from "react";
import { createGRN } from "logic/permissions/GRN";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import { Link } from "components/common";
import useEntityCollectionStatus from "../hooks/useEntityCollectionStatus";
import CollectionsRoutes from "../Routes";
const EntityCollectionList = ({ collections }) => {
  const collectionList = useMemo(
    () => collections.map((collection) => /* @__PURE__ */ React.createElement(ListGroupItem, { key: collection.id }, /* @__PURE__ */ React.createElement(Link, { to: CollectionsRoutes.show(collection.id) }, collection.title))),
    [collections]
  );
  return /* @__PURE__ */ React.createElement(ListGroup, { componentClass: "ul" }, collectionList);
};
const EntityCollectionExpandedSection = ({ entity, entityType }) => {
  const entityGRN = createGRN(entityType, entity.id);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entity.id);
  if (isFetching || isError) {
    return /* @__PURE__ */ React.createElement("p", null, "Loading collections...");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "The ", entityType, " ", entity.title, " is associated with the following collections:"), /* @__PURE__ */ React.createElement(EntityCollectionList, { collections: data || [] }));
};
const getRenderExpandCollections = (entityType) => (entity) => /* @__PURE__ */ React.createElement(EntityCollectionExpandedSection, { entity, entityType });
export const expandedCollectionSections = (entiyType) => ({
  collections: {
    title: "Collections",
    content: getRenderExpandCollections(entiyType)
  }
});
export default EntityCollectionExpandedSection;
